// import { useState } from "react";
// import { useAuth } from "../../hooks/useAuth";

// import Landing         from "./Landing";
// import ResidentLogin   from "./ResidentLogin";
// import ValetLogin      from "./ValetLogin";
// import HOALogin        from "./HOALogin";
// import SuperAdminLogin from "./SuperAdminLogin";
// import SuccessScreen   from "./SuccessScreen";
// import "./auth.css";

// /* ─── Loading Spinner ─── */
// function LoadingScreen() {
//   return (
//     <div style={{
//       minHeight: "100vh", display: "flex",
//       alignItems: "center", justifyContent: "center",
//       background: "var(--g50)", flexDirection: "column", gap: 14,
//       fontFamily: "'Outfit',sans-serif",
//     }}>
//       <div style={{
//         width: 24, height: 24,
//         border: "2.5px solid var(--g200)",
//         borderTopColor: "var(--g600)",
//         borderRadius: "50%",
//         animation: "spin .7s linear infinite",
//       }} />
//       <span style={{ fontSize: 13.5, color: "var(--mut)" }}>Loading…</span>
//     </div>
//   );
// }

// /* ─── Main Auth Orchestrator ─── */
// export default function CanluxaAuth() {
//   const { profile, loading, logout } = useAuth();
//   const [screen, setScreen] = useState("landing");

//   // While Supabase checks existing session
//   if (loading) return <LoadingScreen />;

//   // Already logged in (session restored from previous visit)
//   if (profile && screen !== "success") {
//     return (
//       <SuccessScreen
//         role={profile.role}
//         onReset={async () => {
//           await logout();
//           setScreen("landing");
//         }}
//       />
//     );
//   }

//   const goBack    = () => setScreen("landing");
//   const onSuccess = () => setScreen("success");

//   return (
//     <>
//       {screen === "landing"    && <Landing        onSelect={setScreen} />}
//       {screen === "resident"   && <ResidentLogin  onBack={goBack} onSuccess={onSuccess} />}
//       {screen === "valet"      && <ValetLogin     onBack={goBack} onSuccess={onSuccess} />}
//       {screen === "hoa"        && <HOALogin       onBack={goBack} onSuccess={onSuccess} />}
//       {screen === "superadmin" && <SuperAdminLogin onBack={goBack} onSuccess={onSuccess} />}
//       {screen === "success"    && (
//         <SuccessScreen
//           role={profile?.role}
//           onReset={async () => {
//             await logout();
//             setScreen("landing");
//           }}
//         />
//       )}
//     </>
//   );
// }

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

import Landing         from "./Landing";
import ResidentLogin   from "./ResidentLogin";
import ValetLogin      from "./ValetLogin";
import HOALogin        from "./HOALogin";
import SuperAdminLogin from "./SuperAdminLogin";
import "./auth.css";

const ROLE_ROUTES = {
  super_admin: '/admin/dashboard',
  hoa_admin:   '/hoa/dashboard',
  valet:       '/valet/dashboard',
  resident:    '/resident/dashboard',
};

function LoadingScreen() {
  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "var(--g50)",
      flexDirection: "column", gap: 14, fontFamily: "'Outfit',sans-serif",
    }}>
      <div style={{
        width: 24, height: 24, border: "2.5px solid var(--g200)",
        borderTopColor: "var(--g600)", borderRadius: "50%",
        animation: "spin .7s linear infinite",
      }} />
      <span style={{ fontSize: 13.5, color: "var(--mut)" }}>Loading…</span>
    </div>
  );
}

export default function CanluxaAuth() {
  const { profile, loading } = useAuth();
  const navigate = useNavigate();
  const [screen, setScreen] = useState("landing");

  useEffect(() => {
    if (!loading && profile) {
      const route = ROLE_ROUTES[profile.role];
      if (route) navigate(route, { replace: true });
    }
  }, [profile, loading, navigate]);

  if (loading || profile) return <LoadingScreen />;

  const goBack = () => setScreen("landing");
  const onSuccess = () => {}; // useAuth profile update triggers redirect

  return (
    <>
      {screen === "landing"    && <Landing        onSelect={setScreen} />}
      {screen === "resident"   && <ResidentLogin  onBack={goBack} onSuccess={onSuccess} />}
      {screen === "valet"      && <ValetLogin     onBack={goBack} onSuccess={onSuccess} />}
      {screen === "hoa"        && <HOALogin       onBack={goBack} onSuccess={onSuccess} />}
      {screen === "superadmin" && <SuperAdminLogin onBack={goBack} onSuccess={onSuccess} />}
    </>
  );
}